import { render, staticRenderFns } from "./PetCareDialog.vue?vue&type=template&id=16f58693&scoped=true"
import script from "./PetCareDialog.vue?vue&type=script&lang=js"
export * from "./PetCareDialog.vue?vue&type=script&lang=js"
import style0 from "./PetCareDialog.vue?vue&type=style&index=0&id=16f58693&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f58693",
  null
  
)

export default component.exports